<template>
  <div class="serv_list">
    <ul>
      <li
        v-for="(item, i) in serv_list"
        :key="i"
        class="wow fadeInUp"
        :data-wow-delay="150 + 50 * i + 'ms'"
      >
        <div class="img">
          <img :src="item.smallImg" alt />
        </div>
        <h4>{{ item.name }}</h4>
        <h6>{{ item.title }}</h6>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'service',
  props: {
    info: {
      type: Array
    }
  },
  data() {
    return {
      serv_list: this.info
    }
  }
}
</script>

<style lang="less" scoped>
.serv_list {
  margin-top: 15px;
  ul {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;

    li {
      width: 25%;
      color: #202640;
      padding: 32px 40px 0;
      position: relative;

      &:last-child {
        margin-right: 0;
      }

      .img {
        width: 70px;
        margin: 0 auto;
      }

      h4 {
        font-size: 20px;
        font-weight: bold;
        line-height: 28px;
        text-align: center;
        margin-top: 20px;
      }

      h6 {
        font-size: 16px;
        line-height: 26px;
        margin-top: 10px;
        font-weight: normal;
      }
    }
  }
}

@media (max-width: 1024px) {
  .serv_list {
    ul {
      li {
        width: calc(50% - 20px);
        margin-top: 40px;
        height: auto;

        &:nth-child(-n + 2) {
          margin-top: 0;
        }

        &:nth-child(2n) {
          margin-right: 0;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .serv_list {
    ul {
      li {
        width: 100%;
        margin-top: 20px;
        margin-right: 0;
        padding: 12px 20px 0;

        &:nth-child(-n + 2) {
          margin-top: 20px;
        }

        &:nth-child(-n + 1) {
          margin-top: 0;
        }

        h4 {
          font-size: 18px;
        }
      }
    }
  }
}
</style>
